const admin = {
    namespaced: true,
    state: {
        sub_layout_loading: false,
        answer_loading: false,
    },
    mutations: {
        set_layout_loading(state, loading) {
            state.sub_layout_loading = loading
        },
        set_answer_loading(state, loading) {
            state.answer_loading = loading
        }
    },
    getters: {},
    actions: {
        setLayoutLoading({ commit }, loading) {
            commit('set_layout_loading', loading)
        },
        setAnswerLoading({ commit }, loading) {
            commit('set_answer_loading', loading)
        }
    }
}
export default admin
